export var LightType;
(function (LightType) {
    /**
     * 点光源
     */
    LightType["point"] = "point";
    /**
     * 聚光灯
     */
    LightType["spot"] = "spot";
    /**
     * 方向光
     */
    LightType["directional"] = "directional";
    /**
     * 环境光
     */
    LightType["ambient"] = "ambient";
})(LightType || (LightType = {}));
